/* eslint-disable eslint-comments/disable-enable-pair, max-lines-per-function */
import React, { Fragment } from 'react';
import { useSelector } from 'react-redux';

import LocationRadiusContainer from 'src/containers/LocationRadiusContainer';
import FormSendContainer from 'src/containers/FormSendContainer';
import WorkplaceContainer from 'src/containers/WorkplaceContainer';
import KeywordContainer from 'src/containers/KeywordContainer';

import ChevronRight from '@mdi/svg/svg/chevron-right.svg';


import './SearchForm.scss';


const SearchForm = () => {
  const searchURL = useSelector(({ configReducer }) => configReducer.searchURL);
  const searchTitle = 'Jakiej pracy szukasz?';
  const searchCopy = 'Szukaj';
  const advancedSearchCopy = 'Wyszukiwanie zaawansowane';
  const remoteWorkCopy = 'Praca zdalna';
  const remoteWorkHref = `${searchURL}?rw=true`;

  const renderTitle = () => (
    <div styleName="search-form__title">
      <h2 styleName="search-title">{ searchTitle }</h2>
      <h2 styleName="search-title search-title--desktop">{ searchCopy }</h2>
    </div>
  );

  const renderContent = () => (
    <Fragment>
      <div styleName="search-form__keyword">
        <KeywordContainer />
      </div>
      <div styleName="search-form__workplace">
        <WorkplaceContainer />
      </div>
      <div styleName="search-form__radius">
        <LocationRadiusContainer />
      </div>
      <div styleName="search-form__form-send">
        <FormSendContainer />
      </div>
    </Fragment>
  );

  const renderButtons = () => (
    <Fragment>
      <button
        data-test="advanced-search"
        styleName="advanced-search__action"
        type="submit"
      >
        { advancedSearchCopy }
        <ChevronRight viewBox="0 0 24 24" />
      </button>
      <a
        data-test="anchor-remote-work"
        href={ remoteWorkHref }
        styleName="advanced-search__action"
      >
        { remoteWorkCopy }
        <ChevronRight viewBox="0 0 24 24" />
      </a>
    </Fragment>
  );

  return (
    <form action={ searchURL } data-test="form-search" method="post">
      <div styleName="search-form">
        { renderTitle() }
        { renderContent() }
      </div>
      <div styleName="advanced-search">
        { renderButtons() }
      </div>
    </form>
  );
};

export default SearchForm;
